import { render, staticRenderFns } from "./RobberyAbsenceDatesQuestion.vue?vue&type=template&id=5d8caa44&scoped=true"
import script from "./RobberyAbsenceDatesQuestion.vue?vue&type=script&lang=ts"
export * from "./RobberyAbsenceDatesQuestion.vue?vue&type=script&lang=ts"
import style0 from "./RobberyAbsenceDatesQuestion.vue?vue&type=style&index=0&id=5d8caa44&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8caa44",
  null
  
)

export default component.exports